"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const js_cookie_1 = __importDefault(require("js-cookie"));
const DEVICE_ID_COOKIE_KEY = 'device_id';
const DEVICE_ID_COOKIE_EXPIRATION_DAYS = 400;
const getDeviceId = (domain) => {
    let deviceId = js_cookie_1.default.get(DEVICE_ID_COOKIE_KEY);
    if (!deviceId) {
        deviceId = (0, uuid_1.v4)();
    }
    // Reset cookie expiration each time we get the device id
    js_cookie_1.default.set(DEVICE_ID_COOKIE_KEY, deviceId, {
        path: '/',
        secure: true,
        sameSite: 'lax',
        expires: DEVICE_ID_COOKIE_EXPIRATION_DAYS,
        domain: domain,
    });
    return deviceId;
};
exports.default = getDeviceId;
